import { ThemeProvider,Typography } from '@mui/material';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { ptBR } from 'date-fns/locale';
import { useContext,useEffect } from 'react';
import { WebFormContext } from '../../../../context/WebFormContext';
import { SubItemFormFilling } from '../../../../types/new-form-filling/types';
import { getMuiTheme } from '../../../TableHelpers/options';
import CheckIcon from "../../CheckIcon";
import AdditionalInfo from '../../Structure/AdditionalInfo';

type props = {
  subitem: SubItemFormFilling,
  data: Date | number | null,
  setData: Function,
};

export default function DateComp({
  subitem,
  data,
  setData }: props) {
  const { ForceUpdate } = useContext(WebFormContext);

  const textFieldTitle: string = (() => {
    let title = '';
    if (CheckIcon(subitem, data) === 'naoOk') {
      title += '* ';
    }
    title += `${subitem.id + 1} - ${subitem.nome}`;
    return title;
  })();

  useEffect(() => {
    if (subitem.ocorrencia) {
      setData(subitem.ocorrencia);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (subitem.ocorrencia) return;
    if (subitem.padrao) {
      setData(subitem.padrao);
      subitem.ocorrencia = data as number;
      subitem.checked = true;
    }
    if (CheckIcon(subitem, data) === 'ok') {
      subitem.checked = true;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (data) {
      subitem.ocorrencia = data as number;
      subitem.checked = true;
    }
    if (CheckIcon(subitem, data) === 'ok') {
      subitem.checked = true;
    } else {
      delete subitem.checked;
    }
    ForceUpdate();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  return (
    <>
      <Typography
        variant='h6'
        style={{
          wordBreak: 'break-all',
          marginBottom: '5px',
          width: '100%',
          textAlign: 'left'
        }}>
        {textFieldTitle}
      </Typography>
      <ThemeProvider theme={getMuiTheme()}>
        <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ptBR}>
          <DesktopDatePicker
            className={`${subitem.itemid}|${subitem.id}`}
            sx={{
              height: '100%',
              backfaceVisibility: 'hidden',
              width: '100%'
            }}
            // minDate={new Date(Date.now())}
            format='dd/MM/yyyy'
            value={data ? new Date(data) : null}
            onChange={(newValue) => {
              if (!newValue) return;
              const date = new Date(newValue.getTime());
              date.setHours(0, 0, 0, 0);
              setData(date);
            }}
            slotProps={{
              textField: {
                required: true,
              },
              actionBar: {
                actions: ['clear'],
              },
              field: {
                readOnly: true,
              },
            }}
            localeText={{
              clearButtonLabel: 'Limpar',
            }}
          />
        </LocalizationProvider>
      </ThemeProvider>
      {data && <AdditionalInfo subItem={subitem} />}
    </>
  );
}
